<script>

    import Signup from '../users/signup.svelte'

</script>

<div class="container" style="margin-top: 10%;">
    <div class="columns">
        <div class="column is-4 is-offset-4">
            <Signup />
        </div>
    </div>
</div>